<script>
  import { pmfilters } from "lib/stores.js";
  import LineChartNeu from "lib/components/LineChartNeu.svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import { getApplicableFilters } from "../../../../../lib/util/getApplicableFilters";
  import { tick } from "svelte";

  export let analysisid;
  export function download(currentApp){
    if(lineChart) lineChart.download(currentApp);
  }

  let lineChart; 

  let timeframe = "W";
  let TimeItems = [];
  let activityTimes = [];
  let caseTimes = [];
  let newCaseTimes = [];
  let selectedKPIs = ["activityCount", "caseCount", "newCaseCount"];
  let lastFilterString = "";
  let fetching = false;

  $: updateData();

  async function updateData() {
    if (!analysisid || fetching) return;

    const applicableFilters = getApplicableFilters($pmfilters[analysisid]);
    const newFilterString = JSON.stringify(applicableFilters);

    if (newFilterString === lastFilterString) return;

    lastFilterString = newFilterString;
    fetching = true;

    await tick();

    Promise.all([
      fetchWithSession(
        `/api/analysis/cases/getActivityCountsPerTime/${analysisid}?interval=${timeframe}&filter=${newFilterString}`
      ).then((r) => r.json()),
      fetchWithSession(
        `/api/analysis/cases/getCaseCountsPerTime/${analysisid}?interval=${timeframe}&filter=${newFilterString}`
      ).then((r) => r.json()),
      fetchWithSession(
        `/api/analysis/cases/getNewCaseCountsPerTime/${analysisid}?interval=${timeframe}&filter=${newFilterString}`
      ).then((r) => r.json()),
    ])
      .then(([activityData, caseData, newCaseData]) => {
        activityTimes = activityData;
        caseTimes = caseData;
        newCaseTimes = newCaseData;
      })
      .finally(() => {
        fetching = false;
      });
  }

  $: {
    TimeItems = [];
    if (selectedKPIs.includes("activityCount"))
      TimeItems = TimeItems.concat(activityTimes);
    if (selectedKPIs.includes("caseCount"))
      TimeItems = TimeItems.concat(caseTimes);
    if (selectedKPIs.includes("newCaseCount"))
      TimeItems = TimeItems.concat(newCaseTimes);
  }
</script>

<main>
  <div class="selectors"></div>
  <LineChartNeu
    bind:this={lineChart}
    axes={["y", "y", "y"]}
    width="auto"
    height="80vh"
    dataSets={TimeItems}
  />
</main>

<style>
  main {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  .selectors {
    display: flex;
    gap: 0.5rem;
    max-width: 100%;
    width: 100%;
  }
</style>
